<template >
  <!--
  <pre>placehodler inputObj{{inputObj}}</pre>
   -->
  <h3>{{inputObj.params.title}}</h3>
  <p v-if="inputObj.params.desc">{{inputObj.params.desc}}</p>

  <template
  v-if="inputObj.form"
  >
    <div
        v-for="(item, index) in inputObj.form"
        class="mt-2"
    >
      <template
        v-if="item.type == 'text'"
      >
        <div
          class="row"
        >
          <div
            class="col col-auto d-flex align-items-center"
          >
            <label
                for="index"
            >
               {{item.title}}
            </label>
          </div>
          <div
              class="col"
          >
            <input
                v-model="inputModel[index]"
                type="text"
                class="form-control"
            >
          </div>
        </div>
      </template>
      <template
          v-else-if="item.type == 'number'"
      >
        <div
            class="row"
        >
          <div
              class="col col-auto d-flex align-items-center"
          >
            <label
                for="index"
            >
              {{item.title}}
            </label>
          </div>
          <div
              class="col"
          >
            <input
                v-model="inputModel[index]"
                type="number"
                class="form-control"
            >
          </div>
        </div>
      </template>
      <template
        v-else-if="item.type == 'select'"
      >

        <div
            class="row"
        >
          <div
              class="col col-auto d-flex align-items-center"
          >
            <label
                for="index"
            >
              {{item.title}}
            </label>
          </div>
          <div
              class="col"
          >
            <select
                v-model="inputModel[index]"
                class="form-select"
            >
              <option
                  v-for="(option) in item.options"
                  :value="option.id"
              >
                {{option.title}}
              </option>
            </select>
          </div>
        </div>

      </template>
      <template
          v-else-if="item.type == 'checkbox'"
      >
        <span
            class="label label-default fw-bolder"
        >
          {{item.title}}
        </span>

        <template
          v-for="(checkbox) in item.options"
        >
          <label
              class="form-check-label ms-3"
          >
            <input
              v-model="inputModel[index]"
              type="checkbox"
              :value="checkbox.id"
              class="form-check-input"
            >
            {{checkbox.title}}
          </label>
        </template>
      </template>
      <template
          v-else-if="item.type == 'radio'"
      >
        <span
            class="label label-default fw-bolder"
        >
          {{item.title}}
        </span>

        <template
            v-for="(radio) in item.options"
        >
          <label
              class="form-check-label ms-3"
          >
            <input
                v-model="inputModel[index]"
                type="radio"
                :value="radio.id"
                class="form-check-input"
            >
            {{radio.title}}
          </label>
        </template>
      </template>
      <template
          v-else-if="item.type == 'bool'"
      >
        <div
            class="form-check form-switch"
        >
          <label
            class="form-check-label"
        >
          <input
              v-model="inputModel[index]"
              class="form-check-input"
              type="checkbox"
              role="switch"
          >
            {{item.title}}
          </label>
        </div>
      </template>

    </div>
  </template>

  <template
    v-if="inputObj.params.checkbox_is_generated"
  >

    <div class="form-check form-switch">
      <input
          v-model="inputModel.is_generated"
          class="form-check-input"
          type="checkbox"
          role="switch"
          :id="checkboxId"
      >
      <label
          class="form-check-label"
          :for="checkboxId"
      >
        {{ $t('inputSegment.general.is_generated_title')}}
      </label>
    </div>
  </template>

  <template
      v-if="inputObj.params.is_json_data_transfer"
  >
    <textarea
        v-model="inputModel.data"
        style="visibility: hidden"
        class="form"
    >
    </textarea>
  </template>


  <template v-if="inputObj.params.display_type == 'tags'">
    <ul class="list-group">
      <li
          v-for="tag in inputObj.obsah.data"
        class="list-group-item"
      >
        {{tag.title}}
      </li>
    </ul>

  </template>
  <template v-else-if="inputObj.params.display_type == 'contents'">
  [contents]
  </template>




    <!--
 <display-debug>
    <template #debugView>inputObj: {{inputObj.form}}</template>
  </display-debug>

  <display-debug>
    <template #debugView>inputModel: {{inputModel}}</template>
  </display-debug>

  <display-debug>
    <template #debugView>inputObj.params: {{inputObj.params}}</template>
  </display-debug>
-->
</template>

<script>

import DisplayDebug from "@/components/general/DisplayDebug.vue";
import {generateRandomString} from "@/utils/general";

export default {
  name: "PlaceholderSegment",
  components: {DisplayDebug},
  props: {
    "segmentsObj": [Object, Array],
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, Number, String],
    "lang": {
      type: [Object],
      required: false,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
    },
  },
  data() {
    return {
      inputModel: {
        status: true,
        is_generated: false,
        data: '{}'
      },
      checkboxId: null,
    }
  },
  emits: ['update:modelValue'],
  mounted() {
    //console.log("dev segment mounted inputObj", this.inputObj.obsah)
    this.checkboxId = this.generateRandomString(50)
    //obsah data
    if (
        this.inputObj
        && this.inputObj.obsah
        && this.inputObj.obsah.data
    ) {
      this.inputModel.data = JSON.stringify(this.inputObj.obsah.data)
    }
  //obsah generated status
    if (
        this.inputObj
        && this.inputObj.obsah
        && this.inputObj.obsah.is_generated
    ) {
      this.inputModel.is_generated = this.inputObj.obsah.is_generated
    }

    if (
        this.inputObj
        && this.inputObj.form
    ) {
      for (const i in this.inputObj.form) {
        //console.log("dev segment mounted inputObj form", i, this.inputObj.form[i])
        //check box
        if (this.inputObj.form[i].type == "checkbox") {
          this.inputModel[i] = [];
        }else{
          this.inputModel[i] = null;
        }

        if(this.inputObj.form[i].value) {
          this.inputModel[i] = this.inputObj.form[i].value;
        }
      }
    }


  },
  watch: {
    inputObj: {
      handler() {
        //  this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal, oldVal) {
        if(typeof oldVal != "undefined") {
          //console.log("dev segment watch X1", newVal, oldVal)
          const emitData = {...newVal};
          if(emitData.data) {
            //console.log("dev segment watch inputModel 2", emitData.data)
            try {
              emitData.data = JSON.parse(emitData.data)
            }catch (e) {
              console.log("dev segment watch inputModel ERR", e, emitData.data)
            }

            //
          }else{
            emitData.data = {}
          }
          this.$emit('update:modelValue', emitData )

        }



      },
      deep: true,
      immediate: true



    },
  },


};
</script>
<script setup lang="ts">
</script>